import { forwardRef } from 'react'
import type { InputHTMLAttributes } from 'react'
import { cx } from '../../cx'
import styles from './Input.module.css'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Skrót na aria-invalid — ramka w kolorze --k1-danger przez CSS. */
  invalid?: boolean
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid, className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      {...rest}
      aria-invalid={invalid ?? rest['aria-invalid']}
      className={cx(styles.input, className)}
    />
  )
})
